module.exports = __webpack_public_path__ + "img/badge-senior-resident-darkbg.8b18b2af.svg";